import React from "react"
import { useOutlet } from "react-router-dom"


export const Orders = () => {
  const outlet = useOutlet()

  return <>{outlet}</>
}